import { Component, Input } from '@angular/core';


import { UserPermisionsFactory } from '@shared/factories/user-permisions/user-permisions.factory';
import { TypeIconsPipe } from '@shared/filters/type-icons/type-icons.pipe';
import { NgShowDirective } from '../../directives/ng-show/ng-show.directive';
import { SpanTooltipComponent } from '../span-tooltip/span-tooltip.component';
import { AfTranslateDirective } from '../../modules/translate/directive/af-translate.directive';
import { NgClass } from '@angular/common';
import { CustomLandingFactory } from '@shared/factories/custom-landing/custom-landing.factory';
import { ContextFactory } from '@shared/factories/context/context.factory';
import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';


@Component({
    selector: 'concept-legal-documentation',
    templateUrl: './concept-legal-documentation.component.html',
    standalone: true,
    imports: [NgClass, AfTranslateDirective, SpanTooltipComponent, NgShowDirective, TypeIconsPipe]
})
export class ConceptLegalDocumentationComponent {
  userPermissions: any = this.permissions.getPermissions();
  isLanding: Boolean = this.customLanding.isLanding();
  previewView: boolean = location.pathname.indexOf('preview-customization') !== -1;
  conceptLegalDocumentation:any = {
    fullScreen: false,
  }

  constructor(private context: ContextFactory,
    private permissions: UserPermisionsFactory,
    private customLanding: CustomLandingFactory,
    private modalService: ModalServiceService) {
  }

  @Input() referencesList: any = [];
  @Input() concept: any = null;


  showLegalDocumentation(e:any, reference:any){
    if(!this.previewView){
      let that: any = this.conceptLegalDocumentation;
      // e.stopPropagation();
      // e.preventDefault();
      that.openLaw = !that.openLaw;
      this.getReferencesLaws(reference.type);
      let registerItem ={
        event: 'open legal docs',
        conceptName: sessionStorage.getItem('breadcrumbConcept') + this.concept.title
      }
      this.modalService.lawInfoModal(registerItem, this.referencesList, reference)
        .subscribe((result:any)=>{
          if(result.result !=='ok'){
            that.openLaw = !that.openLaw;
            if(that.showInfo){
              that.showInfo = !that.showInfo;
            }
          }
        })
    }
  }

  getReferencesLaws(type:any){
    let that: any = this.conceptLegalDocumentation;
    that.laws = [];
    this.referencesList.forEach((element:any) => {
      if(element.type ===  type){
        that.laws.push(element);
      }
    });
}
}
